import React, { Component } from 'react';
import { Select } from 'antd';
import SymbolText from './SymbolText'
import Field from './Field';

const { Option } = Select;

class InvestigationType extends Component {
    handleChange = (value, key) => {
        const { data, index, onChange } = this.props;
        switch(key) {
            case 'responsibleFieldId':
                const { symbol, id } = data;
                onChange({
                    id,
                    symbol,
                    responsibleFieldId: value,
                }, index);
                return;
            default:
                data[key] = value;
                break;
        }
        onChange(data, index);
    }

    render() {
        const { data, fieldList, typeList } = this.props;
        const { symbol, responsibleFieldId, typeId } = data;
        const typeOption = typeList.map(d => <Option key={d.projectCategoryId} title={d.projectCategoryName}>{d.projectCategoryName}</Option>);
        return (
            <div>
                <SymbolText symbol={symbol} />
                <div className="border">
                    <Field value={responsibleFieldId} list={fieldList} onChange={this.handleChange} />
                    <span style={{ margin: '0 10px' }}>=</span>
                    <Select
                        value={typeId}
                        placeholder="请选择"
                        style={{ width: 240 }}
                        onChange={(value) => this.handleChange(value, 'typeId')}
                    >
                        {typeOption}
                    </Select>
                </div>
            </div>
        );
    }
}

export default InvestigationType;


// WEBPACK FOOTER //
// ./src/components/user/fieldLeader/components/InvestigationType.js